import config from "./config";
var axios = config();

export default {
  getAreaOfInterestCategories() {
    return axios.get(
      "/api/AreaOfInterestCategories/GetAreaOfInterestCategories",
      {}
    );
  }
};
